import { FC } from 'react';

import { TSelectOption } from 'shared/services/types/common.types';
import { Input } from 'shared/ui/input';
import { SelectSearch } from 'shared/ui/select-multi';

interface IProps {
  methodsOptions?: TSelectOption[];
}

export const GenerationForm: FC<IProps> = ({ methodsOptions }) => {
  return (
    <>
      <Input
        name='applications_per_account'
        label='Number of applications per account'
        placeholder='Enter number'
        type='number'
        rules={{
          required: 'Please, enter number of applications'
        }}
      />
      <Input
        name='transactions_per_account'
        label='Number of transactions per account'
        placeholder='Enter number'
        type='number'
        rules={{
          required: 'Please, enter number of transactions'
        }}
      />
      <Input
        name='percentage_of_transactions'
        label='Percentage of transactions that are not suitable by amount'
        placeholder='Enter the percentage'
        type='number'
        suffix='%'
      />
      <Input
        name='percentage_of_applications'
        label='Percentage of applications that are not suitable by amount'
        placeholder='Enter the percentage'
        type='number'
        suffix='%'
      />
      <SelectSearch
        name='method_id'
        inputLabel='Method'
        inputPlaceholder='All'
        isMulti
        options={methodsOptions}
      />
    </>
  );
};
